import { render, staticRenderFns } from "./EstadoInscripcionDialog.vue?vue&type=template&id=5cc4dc5c&scoped=true&"
import script from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
export * from "./EstadoInscripcionDialog.vue?vue&type=script&lang=js&"
import style0 from "./EstadoInscripcionDialog.vue?vue&type=style&index=0&id=5cc4dc5c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc4dc5c",
  null
  
)

export default component.exports